import React from 'react'
import PropTypes from 'prop-types'
import { Card, Typography } from '@chilecompra/react-kit/components'

/**
 * Sustainable purchases component.
 */
const SustainablePurchases = props => {
  const { isEnvironmental, isSocialEconomic } = props

  if (!isEnvironmental && !isSocialEconomic) return null

  return (
    <Card color="success" margin="0 0 4px">
      <Typography fontWeight="bold" variant="body2">
        Esta compra es sustentable
      </Typography>

      {isEnvironmental && isSocialEconomic && (
        <Typography margin="16px 0 0" variant="body2">
          Esta Compra Ágil considera los requisitos medioambientales, sociales y económicos.
        </Typography>
      )}

      {isEnvironmental && !isSocialEconomic && (
        <Typography margin="16px 0 0" variant="body2">
          Esta Compra Ágil considera los requisitos medioambientales.
        </Typography>
      )}

      {!isEnvironmental && isSocialEconomic && (
        <Typography margin="16px 0 0" variant="body2">
          Esta Compra Ágil considera los requisitos con impacto social y económico.
        </Typography>
      )}
    </Card>
  )
}

SustainablePurchases.defaultProps = {
  isEnvironmental: false,
  isSocialEconomic: false
}

SustainablePurchases.propTypes = {
  isEnvironmental: PropTypes.bool,
  isSocialEconomic: PropTypes.bool
}

export default SustainablePurchases
